import * as Toastr from "toastr";

class SyncIntegrationDialog {
    constructor() {
        $(document).on("click", ".sync-integration-btn", (e) => this.open(e));
    }

    open(e: JQuery.ClickEvent) {
        e.preventDefault();
        const link = $(e.currentTarget);
        const url = link.data("sync-url");
        if (!url) {
            Toastr.error("Could not resolve the integration for this download.");
            return;
        }

        const dialogId = link.data("sync-dialog");
        if (dialogId) {
            $(`#${dialogId}`).modal("show");
            return;
        }

        const dialog = $("#sync-integration-btn");
        const form = dialog.find(".sync-integration-form");
        if (!form.length) {
            Toastr.error("Could not resolve the integration for this download.");
            return;
        }

        form.attr("action", url);
        dialog.find(".sync-integration-name").text(link.data("sync-name"));
        dialog.modal("show");
    }
}

export function LoadPage() {
    new SyncIntegrationDialog();
}
